<template>
  <nav class="navbar">
    <div class="navbar-container">
      <div class="logo">
        <img src="../assets/logo.png" alt="logo" class="logo-img" />
      </div>
      <div class="nav-right">
        <div class="contact-info">
          <div class="contact-phone">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24 11.36 11.36 0 003.55.57 1 1 0 011 1v3.58a1 1 0 01-.91 1 19 19 0 01-8.41-2.41 18.74 18.74 0 01-5.94-5.94A19 19 0 012.5 4.94a1 1 0 011-1H7a1 1 0 011 1 11.36 11.36 0 00.57 3.55 1 1 0 01-.25 1.01z"
                fill="currentColor"
              />
            </svg>
            <span>0591-22828111</span>
          </div>
          <div class="contact-links">
            <span class="divider">|</span>
            <router-link to="/about#careers">加入我们</router-link>
            <!-- <router-link to="/about#contact-us">联系我们</router-link> -->
          </div>
        </div>
        <ul class="nav-menu" :class="{ active: isMenuOpen }">
          <li class="nav-item">
            <router-link to="/" class="nav-link" active-class="active" @click="handleNavClick">网站首页</router-link>
          </li>
          <li class="nav-item has-dropdown">
            <router-link to="/products" class="nav-link" active-class="active" @click="handleNavClick">产品中心</router-link>
            <ul class="dropdown">
              <li class="dropdown-item">
                <router-link to="/products#big-data-platform" class="dropdown-link" @click="handleNavClick">人工智能中心</router-link>
              </li>
              <li class="dropdown-item">
                <router-link to="/products#application-center" class="dropdown-link" @click="handleNavClick">应用中心</router-link>
              </li>
              <!-- <li class="dropdown-item">
                <router-link to="/products#operation-center" class="dropdown-link">运营中心</router-link>
              </li> -->
            </ul>
          </li>
          <li class="nav-item">
            <router-link to="/it" class="nav-link" active-class="active" @click="handleNavClick">IT业务</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/security" class="nav-link" active-class="active" @click="handleNavClick">网络安全</router-link>
          </li>
          <li class="nav-item has-dropdown">
            <router-link to="/news" class="nav-link" active-class="active" @click="handleNavClick">新闻中心</router-link>
            <ul class="dropdown">
              <li class="dropdown-item">
                <router-link to="/news#company-news" class="dropdown-link" @click="handleNavClick">公司新闻</router-link>
              </li>
              <li class="dropdown-item">
                <router-link to="/news#industry-news" class="dropdown-link" @click="handleNavClick">行业新闻</router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item has-dropdown">
            <router-link to="/about" class="nav-link" active-class="active" @click="handleNavClick">关于我们</router-link>
            <ul class="dropdown">
              <li class="dropdown-item">
                <router-link to="/about#company-intro" class="dropdown-link" @click="handleNavClick">企业介绍</router-link>
              </li>
              <li class="dropdown-item">
                <router-link to="/about#culture" class="dropdown-link" @click="handleNavClick">企业文化</router-link>
              </li>
              <li class="dropdown-item">
                <router-link to="/about#careers" class="dropdown-link" @click="handleNavClick">人才招聘</router-link>
              </li>
              <li class="dropdown-item">
                <router-link to="/about#contact-us" class="dropdown-link" @click="handleNavClick">联系我们</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="hamburger" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
    },
    handleNavClick() {
      // 点击任意导航链接后，在小屏幕下关闭菜单
      if (window.innerWidth <= 768) {
        this.closeMenu()
      }
    }
  }
}
</script>

<style scoped>
.navbar {
  position: relative;
  width: 100%;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: all 0.3s ease;
}

.navbar-container {
  /* max-width: 1200px; */
  margin: 0 auto;
  padding: 5px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 70px;
  height: auto;
  gap: 24px;
}

.logo {
  display: flex;
  line-height: 1.2;
  align-items: center;
  margin-left: 20px;
}

.nav-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  padding: 5px;
  margin-right: 20px;
}

.logo-img {
  width: 190px;
  height: 70px;
  margin-right: 10px;
}

.logo h2 {
  color: white;
  margin: 0;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
}

.company-full-name {
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  font-size: 11px;
  font-weight: normal;
  margin-top: 2px;
  line-height: 1;
}

.nav-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 30px;
  width: 100%;
  justify-content: flex-end;
}

.nav-item {
  position: relative;
}

.nav-link {
  color: #333333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 15px;
  border-radius: 5px;
  transition: all 0.3s ease;
  display: block;
}

.dropdown {
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  background: #ffffff;
  border-radius: 8px;
  min-width: 180px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
  padding: 8px 0;
  z-index: 1001;
  /* 动画初始状态 */
  visibility: hidden;
  opacity: 0;
  transform: translateY(8px);
  max-height: 0;
  overflow: hidden;
  transition:
    opacity 550ms cubic-bezier(0.22, 0.61, 0.36, 1),
    transform 050ms cubic-bezier(0.22, 0.61, 0.36, 1),
    max-height 700ms cubic-bezier(0.22, 0.61, 0.36, 1),
    visibility 0s linear 550ms;
}

.has-dropdown:hover .dropdown {
  /* 动画展开状态 */
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
  max-height: 600px; /* 足够容纳多项 */
  overflow: hidden;
  transition:
    opacity 550ms cubic-bezier(0.22, 0.61, 0.36, 1),
    transform 550ms cubic-bezier(0.22, 0.61, 0.36, 1),
    max-height 1750ms cubic-bezier(0.22, 0.61, 0.36, 1),
    visibility 0s;
}

/* 大屏幕下，让二级菜单在父菜单正中间 */
@media (min-width: 1200px) {
  .dropdown {
    left: 50%;
    transform: translate(-50%, 8px);
  }

  .has-dropdown:hover .dropdown {
    transform: translate(-50%, 0);
  }
}

.dropdown-item {
  list-style: none;
}

.dropdown-link {
  display: block;
  padding: 10px 16px;
  color: #1e55a2;
  text-decoration: none;
  font-size: 14px;
  transition: background 0.2s ease, color 0.2s ease;
  white-space: nowrap;
  text-align: center;
}

.dropdown-link:hover {
  background: rgba(30, 85, 162, 0.08);
  color: #0d3a7a;
}

.nav-link:hover,
.nav-link.active {
  background: rgba(76, 149, 227, 0.1);
  color: #4c95e3;
  transform: translateY(-2px);
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 5px;
}

.hamburger span {
  width: 25px;
  height: 3px;
  background: #333333;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.contact-info {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #1e55a2;
  justify-content: flex-end;
}

.contact-phone {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 600;
  color: #409EFF;
  margin-right: 10px;
}

.contact-phone svg {
  width: 24px;
  height: 24px;
}

.contact-links {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #555555;
}

.contact-links a {
  color: inherit;
  text-decoration: none;
  transition: color 0.2s ease;
}

.contact-links a:hover {
  color: #1e55a2;
}

.contact-links .divider {
  color: #bbbbbb;
}

@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }

  .nav-right {
    align-items: center;
  }

  .contact-info {
    display: none;
  }

  .nav-menu {
    position: fixed;
    left: -100%;
    top: 70px;
    flex-direction: column;
    background: #ffffff;
    width: 100%;
    text-align: center;
    transition: 0.3s;
    box-shadow: 0 10px 27px rgba(0, 0, 0, 0.05);
    padding: 20px 0;
    gap: 0;
    width: 100%;
    justify-content: center;
  }

  .nav-menu.active {
    left: 0;
  }

  .nav-item {
    margin: 10px 0;
  }

  .nav-item.has-dropdown {
    position: static;
  }

  .dropdown {
    position: static;
    display: block;
    background: transparent;
    box-shadow: none;
    padding: 0;
    margin-top: 6px;
    /* 覆盖桌面端动画，让移动端直接展开显示 */
    visibility: visible;
    opacity: 1;
    transform: none;
    max-height: none;
    overflow: visible;
  }

  .dropdown-link {
    color: #333333;
    font-size: 15px;
    padding: 8px 12px;
    opacity: 0.9;
    text-align: center;
  }

  .dropdown-link:hover {
    background: rgba(76, 149, 227, 0.1);
    color: #4c95e3;
  }
}
</style>

